<template>
  <v-app>
    <div style="width: 100%; zoom: 0.92; margin: 0 auto; padding: 15px; text-align: left; font-family: 'Times New Roman', Times, serif;">
      <table style="width: 100%;">
        <tr>
          <td v-if="logo!=null" style="width: fit-content; vertical-align: top;"><img :src="logo.src" :height="logo.height" alt="Logo" /></td>
          <td></td>
          <td>&nbsp;</td>
          <td style="width: 35%; vertical-align: text-top; align-items: end;">
            <table v-if="ledger!=null" style="width: 100%">
              <tr>
                <td><span style="font-size: 10pt; font-weight: bold">Ledger</span></td>
                <td style="text-align: right"><span style="font-size: 10pt;">{{ ledger.ledgercode }}</span></td>
              </tr>
              <tr>
                <td><span style="font-size: 10pt; font-weight: bold">Start Date</span></td>
                <td style="text-align: right"><span style="font-size: 10pt;">{{ new Date(ledger.startdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}</span></td>
              </tr>
              <tr>
                <td><span style="font-size: 10pt; font-weight: bold">End Date</span></td>
                <td style="text-align: right"><span style="font-size: 10pt;">{{ new Date(ledger.enddate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}</span></td>
              </tr>
              <tr>
                <td><span style="font-size: 10pt; font-weight: bold">Currency</span></td>
                <td style="text-align: right"><span style="font-size: 10pt;">{{ ledger.primaryCurrency }}</span></td>
              </tr>
              <tr>
                <td><span style="font-size: 10pt; font-weight: bold">SCY</span></td>
                <td style="text-align: right"><span style="font-size: 10pt;">{{ ledger.secondaryCurrency }}</span></td>
              </tr>
            </table> 
          </td>
        </tr>
      </table>
      <div style="padding-top: 5px; padding-bottom: 5px;"></div>
      <table style="width: 100%; padding-bottom: 10px;">
        <tr>
          <td>
            <div align="center" style="padding: 0; line-height: 0;"><h3><b>General Ledger</b></h3></div>
            <p align="center" style="padding: 0; line-height: 0;">
            Period:
              {{ new Date(ledger.startdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}&nbsp;- 
              {{ new Date(ledger.enddate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}
            </p>
          </td>
        </tr>
        <tr><td><div style="height: 10px;">&nbsp;</div></td></tr>
      </table>
      <div style="padding-top: 5px; padding-bottom: 5px;"></div>

                <table v-if="group_transactions.length>0" style="width: 100%" cellpadding="0" cellspacing="0">
                  <tbody v-for="(group) in group_transactions" v-bind:key="group">
                    <tr v-bind:key="group">
                      <th colspan="2" :style="css['row-bottom-left-sm']">{{ AccountName(group) }}</th>
                      <th :style="css['row-bottom-right']" width="10%">Credit</th>
                      <th :style="css['row-bottom-right']" width="10%">Debit</th>
                      <th :style="css['row-bottom-right']" width="10%">SCY</th>
                    </tr>
                    <tr>
                      <td :style="css['row-left']">{{ new Date(ledger.startdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}</td>
                      <td :style="css['row-left']">Opening Balance</td>
                      <td :style="css['row-right']">{{ sum_opening(group, 'credit') }}</td>
                      <td :style="css['row-right']">{{ sum_opening(group, 'debit') }}</td>
                      <td :style="css['row-right']">{{ OpenFCY(group) }}</td>
                    </tr>
                    <tr v-for="(trans) in data_transactions(group)"  v-bind:key="trans._id">
                      <td :style="css['row-left']">{{ new Date(trans.transdate).toLocaleString("en-SG", { year: 'numeric', month: 'numeric', day: 'numeric' }) }}</td>
                      <td :style="css['row-left'] + 'width: 60%;'">{{ trans.transdesc }}</td>
                      <td :style="css['row-right']">{{ TransAmount(trans, 'credit') }}</td>
                      <td :style="css['row-right']">{{ TransAmount(trans, 'debit') }}</td>
                      <td :style="css['row-right']">{{ TransAmount2(trans) }}</td>
                    </tr>
                    <tr><td><div style="height: 10px;">&nbsp;</div></td></tr>
                    <tr>
                      <td colspan="2" :style="css['row-top-left']">TOTAL {{ AccountName(group) }}</td>
                      <td :style="css['row-top-right']">{{ SumCredit(group) }}</td>
                      <td :style="css['row-top-right']">{{ SumDebit(group) }}</td>
                      <td :style="css['row-top-right']">{{ SumFCY(group) }}</td>
                    </tr>
                    <tr>
                      <td colspan="2" :style="css['row-mid-left']">Ending Balance {{ AccountName(group) }}</td>
                      <td :style="css['row-mid-right']">{{ sum_closing(group, 'credit') }}</td>
                      <td :style="css['row-mid-right']">{{ sum_closing(group, 'debit') }}</td>
                      <td :style="css['row-mid-right']">{{ CloseFCY(group) }}</td>
                    </tr>
                    <tr>
                      <td colspan="5" :style="css['row-mid-left']">&nbsp;</td>
                    </tr>
                  </tbody>
                </table>

      <div style="padding-top: 15px; padding-bottom: 15px;"></div>
    </div>
  </v-app>
</template>
<script>
import {mapActions} from "vuex";
import { getLogo } from '../../../util/tools';

export default {
  name: 'PrintGLReport',
  props: {
    id: String
  },
  data() {
    return {
      decimal1: 0,
      decimal2: 0,
      logo: null,
      initvalue: {},
      ledger: {},
      data_company: {},
      transactions: [],
      accounts: [],
      css: {
        'row-top-right': 'padding: 2px; text-align: right; border-top: 2px; border-top-style: solid; font-size:10pt;',
        'row-mid-right': 'padding: 2px; text-align: right; border-top: 2px; border-top-style: none; font-size:10pt;',
        'row-mid-left': 'padding: 2px; text-align: left; border-top: 2px; border-top-style: none; font-size:10pt; font-weight: bold;',
        'row-top-left': 'padding: 2px; text-align: left; border-top: 2px; border-top-style: solid; font-size:10pt; font-weight: bold;',
        'row-bottom-right': 'padding: 2px; text-align: right; border-bottom: 1px; border-bottom-style: solid;',
        'row-bottom-left': 'padding: 2px; text-align: left; border-bottom: 1px; border-bottom-style: solid;',
        'row-bottom-left-sm': 'width:18%; padding: 2px; text-align: left; border-bottom: 1px; border-bottom-style: solid;',
        'row-left': 'text-align: left; padding-top: 2px; padding-bottom: 2px; padding-right: 12px; font-size:10pt;',
        'row-right': 'text-align: right; padding: 3px; font-size:10pt;',
      },
    }
  },
  methods: {
    ...mapActions('PrintApi', ['getGLReportGLRequest', 'getCompanyDataRequest']),
    AccountName(id){
      let result = this.accounts.find(account=>account._id==id);
      return result!=null ? `${result.accountnum}: ${result.accountname}` : '';
    },
    AccountType(id){
      let result = this.accounts.find(account=>account._id==id);
      return result!=null ? result.accounttype : '';
    },
    data_transactions(id){
      let result = this.transactions.filter(trans=>trans.accountid==id);
      return result;
    },
    sum_opening(id, type){
      let result;
      let open = this.ledger.opening_balances.find(item=>item.accountid==id);
      if(open==undefined) result = '';
      else{
        if(open['accounttype']=='Credit' && type=='credit') result = open.creditAmount-open.debitAmount;
        else if(open['accounttype']=='Debit' && type=='debit') result = open.debitAmount-open.creditAmount;
        else result = '';
      }

      if(result!=null & result!='') return result.toLocaleString("en-US", { minimumFractionDigits: this.digits, maximumFractionDigits: this.digits });
      return result;
    },
    sum_closing(id, type){
      let result;
      let transactions = this.data_transactions(id);
      let open = this.ledger.opening_balances.find(item=>item.accountid==id);
      if(transactions==null && open==null) return;
      let open_credit = open!=null ? open.creditAmount : 0;
      let open_debit = open!=null ? open.debitAmount : 0;
            
      let credit = transactions.reduce((a, b) => a + (b.creditAmount), 0);
      let debit = transactions.reduce((a, b) => a + (b.debitAmount), 0);
      if(open==null){
        let account_type = this.AccountType(id);
        if(type=='credit' && account_type=='Credit') result = credit - debit;
        else if(type=='debit' && account_type=='Debit') result = debit - credit;
        else result = '';
      }
      else if(transactions.length==0){
        let account_type = this.AccountType(id);
        if(account_type=='Credit' && type=='credit') result = open_credit - open_debit;
        else if(account_type=='Debit' && type=='debit') result = open_debit - open_credit;
        else result = '';
      }
      else {
        if(open['accounttype']=='Credit' && type=='credit') result = open_credit + credit - open_debit - debit;
        else if(open['accounttype']=='Debit' && type=='debit') result = open_debit + debit - open_credit - credit;
        else result = '';
      }
      if(result!=null & result!='') result = result.toLocaleString("en-US", { minimumFractionDigits: this.digits, maximumFractionDigits: this.digits });
      else result = '';
            
      return result;
    },
    SumCredit(id){
      let transactions = this.data_transactions(id);
      let result = transactions.reduce((a, b) => a + (b.creditAmount), 0);
      result = result.toLocaleString("en-US", { minimumFractionDigits: this.digits, maximumFractionDigits: this.digits });
      return result;
    },
    SumDebit(id){
      let transactions = this.data_transactions(id);
      let result = transactions.reduce((a, b) => a + (b.debitAmount), 0);
      result = result.toLocaleString("en-US", { minimumFractionDigits: this.digits, maximumFractionDigits: this.digits });
      return result;
    },
    SumFCY(id){
      let type = this.AccountType(id);
      let result;
      let transactions = this.data_transactions(id);
      if(type=='Credit') result = transactions.reduce((a, b) => a + (b.creditAmount2-b.debitAmount2), 0);
      else result = transactions.reduce((a, b) => a + (b.debitAmount2-b.creditAmount2), 0);
      result = result.toLocaleString("en-US", { minimumFractionDigits: this.digits, maximumFractionDigits: this.digits });
      return result;
    },
    OpenFCY(id){
      let result;
      let type = this.AccountType(id);
      let open = this.ledger.opening_balances.find(item=>item.accountid==id);
      let open_credit = open!=null ? open.creditAmount2 : 0;
      let open_debit = open!=null ? open.debitAmount2 : 0;

      if(type=='Credit') result = open_credit - open_debit;
      else result = open_debit - open_credit;
      result = result.toLocaleString("en-US", { minimumFractionDigits: this.digits, maximumFractionDigits: this.digits });
      return result;
    },
    CloseFCY(id){
      let result;
      let sum;
      let type = this.AccountType(id);
      let open = this.ledger.opening_balances.find(item=>item.accountid==id);
      let open_credit = open!=null ? open.creditAmount2 : 0;
      let open_debit = open!=null ? open.debitAmount2 : 0;

      let transactions = this.data_transactions(id);
      if(type=='Credit') sum = transactions.reduce((a, b) => a + (b.creditAmount2-b.debitAmount2), 0);
      else sum = transactions.reduce((a, b) => a + (b.debitAmount2-b.creditAmount2), 0);

      if(type=='Credit') result = open_credit - open_debit +  sum;
      else result = open_debit - open_credit +  sum;
      result = result.toLocaleString("en-US", { minimumFractionDigits: this.digits, maximumFractionDigits: this.digits });
      return result;
    },
    TransAmount(trans, type){
      let result;
      if(type=='credit') result = trans.creditAmount;
      else if(type=='debit') result = trans.debitAmount;
      else result = 0;
      result = result.toLocaleString("en-US", { minimumFractionDigits: this.digits, maximumFractionDigits: this.digits });
      return result;
    },
    TransAmount2(trans){
      let result;
      if(trans==null) return '';
      if(trans['accounttype']=='Credit') result = trans.creditAmount2-trans.debitAmount2;
      else result = trans.debitAmount2-trans.creditAmount2;
      result = result.toLocaleString("en-US", { minimumFractionDigits: this.digits, maximumFractionDigits: this.digits });
      return result;
    },
  },
  computed: {
    group_transactions(){
      let array1 = [];
      let array2 = [];
      if(this.ledger==null && this.transactions==null) return [];
      if(this.transactions.length>0) array1 = this.transactions.map((trans)=>{return {accountid: trans.accountid, accountnum: trans.accountnum}});
      if(this.ledger.opening_balances!=null && this.ledger.opening_balances.length>0) array2 = this.ledger.opening_balances.map((trans)=>{return {accountid: trans.accountid, accountnum: trans.accountnum}});
            
      let combined = array1.concat(array2);
      combined.sort((a,b) =>{
        if (b.accountnum > a.accountnum) return -1;
        if (a.accountnum < b.accountnum) return 1;
        return 0;
      });

      let object1 = Object.groupBy(combined, item => { return item.accountid});
      let results = Object.keys(object1);

      return results;
    },
  },
  async created() {
    if(this.id){
      this.initvalue = await this.getGLReportGLRequest(this.id);
      this.ledger = this.initvalue;
      this.transactions = Object.assign([], this.ledger.transactions);
      if(this.initvalue==null) this.$router.push({ path: '/error' });
      this.logo = getLogo(this.initvalue.companyid);
      this.data_company = await this.getCompanyDataRequest(this.initvalue.companyid);

      if(this.data_company!=null){
        this.accounts = this.data_company.accounts!=null ? this.data_company.accounts : [];
        this.decimal1 = this.data_company.options!=null ? this.data_company.options.PrimaryDecimalPlaces : 0;
        this.decimal2 = this.data_company.options!=null ? this.data_company.options.SecondaryDecimalPlaces : 0;
      }
    }
  },
}

</script>

<style src="./../Print.scss" lang="scss"/>
